<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="list-wrap">
        <div v-for="(item, index) in footerItem" :key="'footer-item' + index" class="list-item">
          <div class="list-item__title is-16m">
            {{ item.title }}
          </div>
          <div v-for="(list, index) in item.list" :key="'footer-list' + index" class="list-item__list is-14m" @click="onClickFooterItem(list.link)">
            {{ list.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap">
      <div class="info-container">
        <div class="img-box">
          <img width="187" height="22" src="https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/footer/kpi-footer-logo.png" alt="kpi-footer-logo" />
          <img width="92" height="44" src="https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/footer/insa-footer-logo.png" alt="insa-footer-logo" />
        </div>
        <div class="info-box">
          <div class="is-14r">
            <b>한국인사관리협회</b> | <b>대표</b> : 심상운 | <b>사업자등록번호</b> : 201-81-20379<br />
            <b>주소</b> : 서울시 성동구 성수일로 77 서울숲 IT밸리, 1402호<br />
            <b>이메일</b> : master@insabank.com | <b>고객센터</b> : 02-2268-2501~4 | <b>운영시간</b> : 월~금 09:00~18:00
          </div>
          <div class="is-14r">Copyright 2024 © KPI한국인사관리협회. All Rights Reserved.</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {useMemberStore} from '~/store/member/index.js'

export default {
  setup() {
    const memberStore = useMemberStore()
    return {memberStore}
  },
  mounted() {
    this.isAuth = this.memberStore.isAuthenticated
  },
  data() {
    return {
      isAuth: false,
      footerItem: [
        {
          title: '회원사업',
          list: [
            {name: '한국인사관리자 월례미팅', link: '/membership-business?menu=0&subMenu=0'},
            {name: '교육연수담당자 월례미팅', link: '/membership-business?menu=1&subMenu=0'},
            {name: '인사팀(부)장 교류회', link: '/membership-business?menu=2&subMenu=0'},
            {name: 'Korea CHO Forum', link: '/membership-business?menu=3&subMenu=0'}
          ]
        },
        {
          title: '공개강좌',
          list: [
            {name: '교육과정', link: '/seminar?menu=0&subMenu=0'},
            {name: '접수중인 교육과정', link: '/seminar?menu=1&subMenu=0'},
            {name: '교육장 안내', link: '/seminar?menu=2&subMenu=0'},
            {name: '교육 신청 안내', link: '/seminar?menu=3&subMenu=0'}
          ]
        },
        {
          title: '월간인사관리',
          list: [
            {name: '월간인사관리 안내', link: '/magazine?menu=0&subMenu=0'},
            {name: '목차', link: '/magazine?menu=1&subMenu=0'},
            {name: '월호보기', link: '/magazine?menu=2&subMenu=0'}
          ]
        },
        {
          title: 'KPI 도서',
          list: [{name: 'KPI 도서', link: '/kpi-book'}]
        },
        {
          title: 'HR 자료',
          list: [
            {name: '인사관리규정', link: '/hr?menu=0&subMenu=0'},
            {name: '연봉 조사 자료', link: '/hr?menu=1&subMenu=0'},
            {name: 'HR 용어', link: '/hr?menu=2&subMenu=0'}
          ]
        },
        {
          title: '고객센터',
          list: [
            {name: '공지사항', link: '/customer-service?menu=0'},
            {name: '찾아오시는 길', link: '/customer-service?menu=1'},
            {name: '1:1 문의', link: '/customer-service?menu=2'},
            {name: '자주 묻는 질문', link: '/customer-service?menu=3'},
            {name: '비용 관련 서류', link: '/customer-service?menu=4'}
          ]
        },
        {
          title: '회사정보',
          list: [
            {name: 'KPI 사업안내', link: '/greeting?menu=0'},
            {name: '사업안내서', link: '/greeting?menu=1&subMenu=0'},
            {name: 'English', link: '/greeting?menu=2&subMenu=0'}
          ]
        },
        {
          title: '인사뱅크',
          list: [
            {name: '인사뱅크 소개', link: '/insa'},
            {
              name: '이용약관',
              link: '/insa?menu=1'
            }
          ]
        },
        {
          title: '이용방침',
          list: [
            {
              name: '개인정보 취급방침',
              link: '/terms?menu=0'
            },
            {
              name: '이메일무단수집 거부',
              link: '/terms?menu=1'
            },
            {
              name: '지적재산권 안내',
              link: '/terms?menu=2'
            }
          ]
        },
        {
          title: '인사말',
          list: [{name: '대표이사 인사말', link: '/ceo'}]
        },
        {
          title: '광고 제휴 문의',
          list: [
            {name: '서비스 안내', link: '/partnership?menu=0'},
            {name: '서비스 문의', link: '/partnership?menu=1'}
          ]
        }
      ],
      businessInfo: {}
    }
  },
  methods: {
    onClickFooterItem(link) {
      const loginRequired = ['/partnership?menu=1']
      if (loginRequired.includes(link) && !this.isAuth) {
        alert('로그인 후 이용 가능합니다.')
        return
      }
      this.$router.push(link)
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  border-top: 1px solid #dbdbdb;

  .footer-container {
    width: 1080px;
    margin: 0 auto;
    padding: 60px 0;

    .list-wrap {
      display: flex;
      gap: 48px 15px;
      flex-wrap: wrap;
      justify-content: flex-end;

      .list-item {
        // 마커 안나오게
        list-style: none;
        width: 160px;

        .list-item__title {
          margin-bottom: 8px;
          font-size: 16px;
          font-weight: 500;
        }

        .list-item__list {
          color: #212121;
          margin-bottom: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          font-family: 'Pretendard', sans-serif;

          &:hover {
            color: #0064b1;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .info-wrap {
    background: var(--Cool-Gray-Cool-Gray-50, #f2f4f8);
    padding: 60px 0;
    @media (max-width: 768px) {
      width: fit-content;
    }

    .info-container {
      width: 1080px;
      margin: 0 auto;
      display: flex;
      gap: 60px;
    }

    .img-box {
      display: flex;
      gap: 15px;
      flex-direction: column;
    }

    .info-box {
      .is-14r {
        color: var(--Cool-Gray-Cool-Gray-500, #697077);
        margin-bottom: 8px;
        font-family: 'Pretendard', sans-serif;
      }

      .is-12r {
        color: var(--Cool-Gray-Cool-Gray-500, #697077);
        font-family: 'Pretendard', sans-serif;
      }

      b {
        margin: 0 1px;
      }
    }
  }
}
</style>
